import { render, staticRenderFns } from "./RecruitmentContactTable.vue?vue&type=template&id=64b85cb8&scoped=true&lang=pug"
import script from "./RecruitmentContactTable.vue?vue&type=script&lang=ts"
export * from "./RecruitmentContactTable.vue?vue&type=script&lang=ts"
import style0 from "./RecruitmentContactTable.vue?vue&type=style&index=0&id=64b85cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b85cb8",
  null
  
)

export default component.exports